import { ITab } from '@framework/ui/Pages/Landing/Sections/TabsSlider/interface';
import activity from './assets/activity.webp';
import targeting from './assets/targeting.webp';
import notes from './assets/notes.webp';
import unlocked from './assets/unlocked.webp';
import IconInvestorTargeting from '@dealroadshow/uikit-icon/IconInvestorTargeting';
import IconUsers from '@dealroadshow/uikit-icon/IconUsers';
import IconDescription from '@dealroadshow/uikit-icon/IconDescription';
import IconOrderbook from '@dealroadshow/uikit-icon/IconOrderbook';

export const marketingProcessTab: ITab[] = [
  {
    key: 'generatePredictiveInvestorTargetLists',
    icon: IconInvestorTargeting,
    title: 'Generate predictive investor target lists on Deal Roadshow',
    description: (
      <p>
        “Investor Targeting” on Deal Roadshow generates real-time target lists and syndication
        benchmarking using your historical allocations and Deal Roadshow investor engagement analytics.
      </p>
    ),
    img: {
      src: targeting.src,
      width: 1420,
      height: 896,
    },
    imgLabel: 'Investor Targeting generates target lists with recommended Contacts from your top investors.',
  },
  {
    key: 'analyzeInvestorAllocations',
    icon: IconUsers,
    title: 'Analyze investor allocations across time on their Account profile',
    description: (
      <p>
        FINSIGHT investor mapping provides deep visibility into an Account’s entire
        engagement history across Deal Roadshow, Allocate, Evercall and more.
      </p>
    ),
    img: {
      src: activity.src,
      width: 1420,
      height: 896,
    },
    imgLabel: 'See historical investor engagement across deals and time on FINSIGHT’s organized Account profiles.',
  },
  {
    key: 'leaveNotes',
    icon: IconDescription,
    title: 'Leave notes for fuller context and easier collaboration',
    description: (
      <p>
        Share Account and Contact-specific notes across your team to create an organized,
        scalable archive for efficient communication.
      </p>
    ),
    img: {
      src: notes.src,
      width: 1420,
      height: 896,
    },
    imgLabel: 'Leave and share notes linked to Deal Roadshows, Allocations, calls, emails and more. ',
  },
  {
    key: 'allocateToInvestors',
    icon: IconOrderbook,
    title: 'Allocate to investors in real-time from online order submissions',
    description: (
      <p>
        Enable syndicate and sales teams to seamlessly manage investor orders and allocate shares during a new issue
        process with OrderBook, FINSIGHT’s book building solution. It’s secure, intuitive, easily shared, supports
        role-based permissions and is fully integrated with Deal Roadshow and Allocate.
      </p>
    ),
    img: {
      src: unlocked.src,
      width: 1420,
      height: 896,
    },
    imgLabel: 'Instantly gauge subscription levels with Allocation visualizations on OrderBook.',
  },
];
